import React from 'react';
// import { Link } from 'react-router-dom';
import Filters from '../../../other/filters';
import * as CardComponents from '../../Common/CardComponents';
import cx from '../../../styles';

const MemoryCardComponent = ({booth, message, author, actions, responseBar, inFeed=false, t, visibleTime='', siteUrl, match, cardName, id}) => {
    const { AuthorLink, LastSeen, ActionLink, ResponseBar } = CardComponents;
    const imageWrapContent = (inFeed && message.length > 100) ? Filters.process(['hashtagify'], message.slice(0, 100)) : Filters.process(['hashtagify'], message);

    return (
        <div className={cx("card-template", "memory-card-component")}>
            <div className={cx("memory-img-wrap")}>
                { booth.images.length ? <img src={booth.images[0].image} alt="memory" loading="lazy"/> : "" }

                <a className="booth-content" href={`/booth/${booth.id}`} dangerouslySetInnerHTML={{__html: imageWrapContent}}></a>

                { message.length > 100 && inFeed && <a className="booth-link" href={`/booth/${booth.id}`}>..{t('lp_read_more')}</a> }
            </div>

            <section className={cx("post-section")}>
                <div className={cx("post-section-header")}>
                    <div className={cx("left")}>
                        <AuthorLink id={author.id} slug={author.slug ? siteUrl + author.slug : ''} url={author.url} fullName={author.fullname}
                            tagLine={author.tagline} imageUrl={author.image} />
                    </div>

                    <div className={cx("right")}>
                        <LastSeen lastSeen={visibleTime} />
                        <ActionLink actions={actions} match={match} cardName={cardName} id={id} />
                    </div>
                </div>

                <div className={cx("post-section-body")}>
                    <ResponseBar likes={responseBar.likes} inFeed={inFeed} replyCount={responseBar.replyCount} url={`/booth/${booth.id}`}
                        onLikeClick={responseBar.onLikeClick} onReplyClick={responseBar.onReplyClick} onShareClick={responseBar.onShareClick} />
                </div>
            </section>
        </div>
    );
}

export default MemoryCardComponent;
